import { Component, OnInit } from "@angular/core";
import { LeadSubmitService } from "../lead-submit/lead-submit.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";

@Component({
    selector: 'logzy-blank-lead',
    templateUrl: './blank-lead.component.html',
    styleUrls: ['../request-details.scss', './blank-lead.component.html']
})
export class BlankLeadComponent implements OnInit {

    loading: boolean = true;

    constructor(
        private leadService: LeadSubmitService,
        private route: ActivatedRoute,
        private router: Router,
        private authService: AuthService,
    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {

            if ('lead_id' in params) {
                this.createRequestByLeadId(params['lead_id']);
            }
        });
    }

    createRequestByLeadId(lead_id) {
        this.loading = true;
        this.leadService.saveLeadRequest(lead_id).subscribe({
            next: res => {
                localStorage.removeItem('lead_request');
                this.navigateToRequestDetails(this.leadService.lead.id)
                this.loading = false;
            },
            error: err => {
                console.log("error", err);
            }
        })
    }

    navigateToRequestDetails(request_id) {
        if (this.authService.isCustomer()) {
            this.route.queryParams.subscribe(params => {
                if ('rType' in params) {
                    if (params['rType'] == 'one_way')
                        this.router.navigateByUrl(`/web-request/lead-request/one-way-details?lead_id=${params['lead_id']}`);
                    if (params['rType'] == 'buy_sell')
                        this.router.navigateByUrl(`/web-request/lead-request/trading-details?lead_id=${params['lead_id']}`);
                    if (params['rType'] == 'lease')
                        this.router.navigateByUrl(`/web-request/lead-request/lease-details?lead_id=${params['lead_id']}`);
                }
            });
            // this.router.navigateByUrl(`/client-dashboard/my-orders/my-order-details?id=${request_id}`);
        }
        if (!this.authService.isCustomer()) {
            this.router.navigateByUrl(`/requests/request-processing/request-details?id=${request_id}`);
        }
    }

}